/* eslint-disable */
<template>
  <div>
    <!-- copy-right-section -->
    <footer class="cpoy-right-bg">
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <div class="social-footer">
              <ul>
                <li><a href="https://www.facebook.com/raotoffice" target="_blank"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
                
              </ul>
            </div>
          </div>
          <div class="col-md-12 text-center">
            <p class="copyright">การยางแห่งประเทศไทย</p>
          </div>
        </div>
      </div>
    </footer>
    <!--end copy right section-->

    <!-- Tap to top -->
    <div class="tap-top">
      <div>
        <i class="fa fa-angle-up" aria-hidden="true"></i>
      </div>


    </div>
    <div id="fb-root"></div>
    <div class="fb-customerchat"
         attribution=setup_tool
         page_id="2123438804574660"
         theme_color="#8E49DD"
         logged_in_greeting="Hi! Welcome to PixelStrap Themes  How can we help you?"
         logged_out_greeting="Hi! Welcome to PixelStrap Themes  How can we help you?">
    </div>

  </div>
</template>
<script>
import $ from 'jquery'
export default {
  name: 'Copyright',
  mounted () {
    this.backtotop()
  },
  methods: {
    backtotop () {
      $(document).ready(function () {
        (function (d, s, id) {
          var js
          var fjs = d.getElementsByTagName(s)[0]
          if (d.getElementById(id)) return
          js = d.createElement(s); js.id = id
          js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js#xfbml=1&version=v2.12&autoLogAppEvents=1'
          fjs.parentNode.insertBefore(js, fjs)
        }(document, 'script', 'facebook-jssdk'))

        $(window).on('scroll', function () {
          if ($(this).scrollTop() > 600) {
            $('.tap-top').fadeIn()
          } else {
            $('.tap-top').fadeOut()
          }
        })
        $('.tap-top').on('click', function () {
          $('html, body').animate({
            scrollTop: 0
          }, 600)
          return false
        })
      })
      $(window).scroll(function () {
        var scroll = $(window).scrollTop()
        if (scroll >= 60) {
          $('.navbar').addClass('darkHeader')
        } else {
          $('.navbar').removeClass('darkHeader')
        }
      })
      $('nav a').on('click', function (event) {
        if (this.hash !== '') {
          event.preventDefault()
          var hash = this.hash
          $('html, body').animate({
            scrollTop: $(hash).offset().top - 50
          }, 1000, function () {
          })
          return false
        }
      })
      if ($(window).width() >= 991) {
        $('nav a').on('click', function (event) {
          if (this.hash !== '') {
            event.preventDefault()
            var hash = this.hash
            $('html, body').animate({
              scrollTop: $(hash).offset().top - 50
            }, 1000)
          }
        })
      } else {
        $('nav a').on('click', function (event) {
          if (this.hash !== '') {
            event.preventDefault()
            var hash = this.hash
            $('html, body').animate({
              scrollTop: $(hash).offset().top - 0
            }, 1000, function () {
            })
          }
        })
      }
    }
  }
}
</script>
